import styled from 'styled-components';
import { BoxFlexAllCentered } from '../Main/common/styles';
import { Button, Form } from 'antd';

type AuthContainerProps = {
  logo: string;
};

type AuthFormMainTitleProps = {
  color?: string;
};

export const AuthContainer = styled(BoxFlexAllCentered)`
  height: 100vh;
  background: url(${(props: AuthContainerProps) => props.logo}) no-repeat 90% 3%,
    radial-gradient(circle at 0 0, #daebf4 var(--r, 150px), transparent 0),
    radial-gradient(circle at 100% 100%, #daebf4 var(--r, 150px), transparent 0);
`;

export const AuthFormContainer = styled.div`
  padding: 20px;
  border-radius: 3px;
  @media screen and (min-width: 768px) {
    width: 55%;
    height: 52%;
    background-color: #fff;
    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2);
  }
  @media screen and (min-width: 1024px) {
    width: 44%;
  }
  @media screen and (min-width: 1440px) {
    width: 31%;
  }
  @media screen and (min-width: 1600px) {
    width: 34%;
  }
  @media screen and (min-width: 1800px) {
    width: 23%;
    height: 46%;
  }
`;

export const AuthFormTitle = styled.div`
  font-size: 0.98em;
  line-height: 1.3em;
`;

export const AuthFormMainTitle = styled.span`
  font-size: 1.65em;
  font-weight: 500;
  ${(props: AuthFormMainTitleProps) => props?.color && `color: ${props.color};`};
`;

export const AuthFormNewAccount = styled(AuthFormTitle)`
  display: flex;
  justify-content: center;
  margin-top: 60px;
`;

export const AuthFormRegister = styled.span`
  color: #3a6a75;
  font-weight: 600;
`;

export const AuthForm = styled(Form)`
  .ant-form-item-has-error {
    text-align: left;
  }

  input,
  .ant-input-affix-wrapper,
  input:hover,
  .ant-input-affix-wrapper:hover,
  input:focus,
  .ant-input-affix-wrapper:focus {
    border-width: 0 0 1px 0 !important;
    border-bottom: 1px solid #d6e0e2;
  }
`;

export const RememberMeSection = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const RememberMeText = styled.span`
  font-size: 0.98em;
`;

export const ButtonAuth = styled(Button)`
  font-weight: bold;
  width: 60%;
  height: 35px;
  border-radius: 35px;
  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2);
`;
